var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var EMPTY_STORAGE_DATA = {
    columnSizes: {},
    columnVisibility: {},
    columnOrders: {}
};
var InMemoryDataGridPersistentStorage = /** @class */ (function () {
    function InMemoryDataGridPersistentStorage() {
        this.store = EMPTY_STORAGE_DATA;
    }
    InMemoryDataGridPersistentStorage.prototype.save = function (payload) {
        this.store.columnSizes = payload.columnSizes;
        this.store.columnVisibility = payload.columnVisibility;
        this.store.columnOrders = payload.columnOrders;
    };
    InMemoryDataGridPersistentStorage.prototype.read = function () {
        return __assign({}, this.store);
    };
    return InMemoryDataGridPersistentStorage;
}());
export { InMemoryDataGridPersistentStorage };
//# sourceMappingURL=InMemoryDataGridPersistentStorage.js.map